import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import {
    Button,
    TextField,
    InputAdornment,
    IconButton,
    CircularProgress,
    Typography,
    Grid,
} from "@material-ui/core";

import VisibilityIcon from '@material-ui/icons/Visibility';
import VisibilityOffIcon from '@material-ui/icons/VisibilityOff';
import NotificationImportantIcon from '@material-ui/icons/NotificationImportant';
import LockIcon from '@material-ui/icons/Lock';

import Alert from '@material-ui/lab/Alert';

import {
    Translate
} from "src/shared_modules/i18n";

import { withMatomo } from 'src/shared_modules/veu-visitors-core/components/common/matomo-tracking';

import {
    showPopover,
    hidePopover,
} from 'src/shared_modules/veu-visitors-core/actions/popovers';

import {
    updateAccount,
    deleteAccount,
} from 'src/shared_modules/veu-visitors-core/actions/user';

class PopoverAccount extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            error : "",
            canSend : false,
            isBusyUpdate : false,
            isBusyDelete : false,
            failed: false,
            fields: {
            },
            fieldErrors : {
            },
            showPassword : false,
            showNewPassword : false,
        }
    }

    componentDidMount() {
        this.setState({
            fields: {
                username : this.props.user.username,
                email : this.props.user.profile.email,
                password : "",
                newPassword : "",
                newPasswordRepeat : "",
            }
        });

    }

    clickCancel() {
        // TODO send cancel to Plazz API if isBusy = true

        this.setState({
            isBusyUpdate : false,
            isBusyDelete : false,
            fields: {
                username : "",
                email : "",
                password : "",
                newPassword : "",
                newPasswordRepeat : "",
            },
            fieldErrors : {
            },
            error: "", // errorcode
            canSend: false,
            canDelete: false,
            failed: false,
            showPassword : false,
            showNewPassword : false,
        });
        this.props.hidePopover("Profile");
    }

    async clickSend() {
        if( this.state.isBusyUpdate || this.state.isBusyDelete || !this.state.canSend )
            return;

        this.setState({
            isBusyUpdate: true,
            failed: false,
            error: "",
            fieldErrors: {},
        });

        let error = await this.props.updateAccount(
                this.state.fields
            );

        if( error !== false ) {

            this.setState({
                failed: true,
                isBusyUpdate: false,
                error: "popovers.account.failed." + error,
                fieldErrors :  this.markFieldErrors(error)
             });

        } else {
            this.setState({
                isBusyUpdate: false,
                canSend: false
            });

            if (this.props.openInUserTabContainer === false) {
                this.props.hidePopover("Account");

                if( this.props.userPlazz.forcePrivacySetup ) {
                    this.props.showPopover("Privacy");
                }
            }
        }
    }

    async clickDelete() {
        if( this.state.isBusyUpdate || this.state.isBusyDelete || !this.state.canSend )
            return;

        this.setState({
            isBusyDelete: true,
            failed: false,
            error: "",
            fieldErrors: {},
        });

        let error = await this.props.deleteAccount(
                this.state.fields
            );

        if( error !== false ) {

            this.setState({
                failed: true,
                isBusyDelete: false,
                error: "popovers.account.failed." + error,
                fieldErrors: this.markFieldErrors(error)
            });

        } else {
            this.props.hidePopover("Account");
            this.props.trackEvent("deleteAccount","success","local");
        }
    }

    markFieldErrors( errorcode ) {
        let fieldErrors = {};
        if( errorcode === "passwordDoesNotMatch" ) {
            fieldErrors["newPassword"] = true;
            fieldErrors["newPasswordRepeat"] = true;
        } else if( errorcode === "dublicateUsername" ) {
            fieldErrors["username"] = true;
        } else if( errorcode === "weakPassword" ) {
            fieldErrors["newPassword"] = true;
        } else if( errorcode === "passwordInvalid" ) {
            fieldErrors["password"] = true;
        } else  {
            // maybe we have additional error codes from plazz here

            // but in all other cases we mark the fields
            fieldErrors[errorcode] = true;
        }
        return fieldErrors;
    }

    validateInput(value) {
        // just not empty
        if( value === undefined || value === null || value.trim() === "" )
            return false;

        return true;
    }

    validateFields() {
        let canSend = true;
        let fields = this.state.fields;

        if( !this.validateInput(fields["password"]) )
            canSend = false;

        return canSend;
    }

    handleInputChange( field, event ) {
        event.preventDefault();
        // update the field value
        let fields = this.state.fields;
        let val = event.target.value;
        fields[field] = val;
        let canSend = this.validateFields();

        this.setState({
                fields : fields,
                canSend : canSend,
                fieldErrors: {},
            });
    }

    togglePasswordVisibility() {
        this.setState({ showPassword : !this.state.showPassword });
    }

    toggleNewPasswordVisibility() {
        this.setState({ showNewPassword : !this.state.showNewPassword });
    }

    renderSubheadline( title ) {
        return(<Grid item xs={12}>
                <Typography color="primary" variant="subtitle2"
                        style={{ marginBottom: 4, marginTop: 12 }}
                    >
                    <Translate>{title}</Translate>
                </Typography>
            </Grid>);
    }

    renderButtonBar() {
        return(<div className="user-form-button-bar none-scroll">
                    <Button variant="contained"
                            fullWidth
                            color="secondary"
                            onClick={() =>{ this.clickSend();} }
                            type="submit"
                            disabled={!this.state.canSend }
                            endIcon={ this.state.isBusyUpdate && <CircularProgress color="inherit" size={20} /> }
                        >
                        <Translate>popovers.profile.send</Translate>
                    </Button>
            </div>);
    }

    renderAccountData() {
        return (<React.Fragment>
                    <TextField id="username" key="username"
                            style={{ marginBottom: 8,  marginTop: 12 }}
                            fullWidth
                            label={<Translate>person-labels.username</Translate>}
                            variant="outlined"
                            value={this.state.fields["username"]}
                            disabled
                            InputProps={{ endAdornment:
                                <InputAdornment position="end">
                                    <LockIcon />
                                </InputAdornment>
                            } }
                        />
                    { this.renderSubheadline("popovers.account.change-email") }

                    <TextField id="email" key="email"
                            style={{ marginBottom: 8, marginTop: 8 }}
                            fullWidth
                            label={<Translate>person-labels.email</Translate>}
                            variant="outlined"
                            type="email"
                            value={this.state.fields["email"]}
                            error={this.state.fieldErrors["email"]}
                            onChange={(e)=>{this.handleInputChange("email",e);}}
                        />
            </React.Fragment>);
    }

    renderPwdChangeHint() {
        return (<React.Fragment>
                <div className="user-form-hint">
                    <Alert variant="filled" icon={<NotificationImportantIcon color="primary" fontSize="large" />}>
                        <Typography color="primary" variant="caption">
                            <Translate>popovers.account.require-pwd-change-hint</Translate>
                        </Typography>
                    </Alert>
            </div>
        </React.Fragment>);
    }

    renderPasswordChange() {

        return(<React.Fragment>
                { this.renderSubheadline("popovers.account.change-password") }
                { this.props.user.isTmpPwd && this.renderPwdChangeHint() }
                <TextField id="newPassword"  key="newPassword"
                        margin="normal"
                        fullWidth
                        autoComplete="off"
                        label={<Translate>popovers.account.new-password</Translate>}
                        variant="outlined"
                        value={this.state.fields["newPassword"]}
                        error={ this.props.user.isTmpPwd || this.state.fieldErrors["newPassword"]}
                        onChange={(e)=>{this.handleInputChange("newPassword",e);}}
                        type={this.state.showNewPassword ? 'text' : 'password'}
                        InputProps={{ endAdornment:
                            <InputAdornment position="end">
                                <IconButton aria-label="toggle password visibility"
                                        onClick={()=> this.toggleNewPasswordVisibility() }
                                        edge="end"
                                    >
                                    { this.state.showNewPassword ? <VisibilityIcon /> : <VisibilityOffIcon />}
                                </IconButton>
                            </InputAdornment>
                        } }
                    />
                <TextField id="newPasswordRepeat"  key="newPasswordRepeat"
                        fullWidth
                        autoComplete="off"
                        label={<Translate>popovers.account.new-password-repeat</Translate>}
                        variant="outlined"
                        value={this.state.fields["newPasswordRepeat"]}
                        error={this.state.fieldErrors["newPasswordRepeat"]}
                        onChange={(e)=>{this.handleInputChange("newPasswordRepeat",e);}}
                        type={this.state.showNewPassword ? 'text' : 'password'}
                        InputProps={{ endAdornment:
                            <InputAdornment position="end">
                                <IconButton aria-label="toggle password visibility"
                                        onClick={()=> this.toggleNewPasswordVisibility() }
                                        edge="end"
                                    >
                                    { this.state.showNewPassword ? <VisibilityIcon /> : <VisibilityOffIcon />}
                                </IconButton>
                            </InputAdornment>
                        } }
                    />
                <Typography variant="body2" component="div" className="input-hint-color" style={{ marginBottom: 8 }}>
                    <Translate>popovers.account.new-password-hint</Translate>
                </Typography>
            </React.Fragment>);
    }

    renderConfirm() {
        return(<React.Fragment>
                { this.renderSubheadline("popovers.account.confirm") }
                <TextField id="password"  key="password" style={{ marginBottom: 8 }}
                        required
                        margin="normal"
                        fullWidth
                        autoComplete="off"
                        label={<Translate>person-labels.password</Translate>}
                        variant="outlined"
                        value={this.state.fields["password"]}
                        error={this.state.fieldErrors["password"]}
                        onChange={(e)=>{this.handleInputChange("password",e);}}
                        type={this.state.showPassword ? 'text' : 'password'}
                        InputProps={{ endAdornment:
                            <InputAdornment position="end">
                                <IconButton aria-label="toggle password visibility"
                                        onClick={()=> this.togglePasswordVisibility() }
                                        edge="end"
                                    >
                                    { this.state.showPassword ? <VisibilityIcon /> : <VisibilityOffIcon />}
                                </IconButton>
                            </InputAdornment>
                        } }
                    />
            </React.Fragment>);
    }

    renderAccountDelete() {
        return(<React.Fragment>
                <Button className="danger-color account-delete-btn"
                        onClick={() =>{ this.clickDelete();} }
                        disabled={!this.state.canSend }
                        endIcon={ this.state.isBusyDelete && <CircularProgress color="inherit" size={20} /> }
                    >
                    <Translate>popovers.account.delete-button</Translate>
                </Button>
                <Typography variant="body2" component="div" className="input-hint-color" style={{ marginBottom: 8 }}>
                    <Translate>popovers.account.delete-hint</Translate>
                </Typography>
            </React.Fragment>);

    }

    render() {

        if( !this.props.showAccount )
            return(null);

        return (<React.Fragment>
                {this.state.failed &&<React.Fragment>
                    <Alert variant="outlined" severity="error" className="none-scroll">
                        <Translate>{this.state.error}</Translate>
                    </Alert>
                    <p></p>
                </React.Fragment>}
                <form onSubmit={(e)=>{e.preventDefault();} } >
                        <Grid container
                                xl={12}
                                direction="column"
                                justify="flex-start"
                                alignItems="flex-start"
                            >

                            { this.renderAccountData() }
                            { this.renderPasswordChange() }
                            { this.renderConfirm() }
                            { this.renderAccountDelete() }
                        </Grid>
                    </form>
                { this.renderButtonBar() }
            </React.Fragment>);
    }
}

PopoverAccount.propTypes = {
    meaconfig: PropTypes.object,
    eventpath: PropTypes.string,
    showAccount: PropTypes.bool,
    user : PropTypes.object,
};


/*
 * ---------------------------------------------------------------------
 * PopoverLogin Redux Container
 * ---------------------------------------------------------------------
 */
const mapStateToProps = ( state, ownProps ) => {
    return {
        showAccount : state.popovers.showAccount,
        user: state.user,
    };
};
const mapDispatchToProps = {
    showPopover,
    hidePopover,
    updateAccount,
    deleteAccount,
};

/*
 * ---------------------------------------------------------------------
 * Export the redux container
 * ---------------------------------------------------------------------
 */
export default connect(
        mapStateToProps,
        mapDispatchToProps
    )(withMatomo(PopoverAccount));
